import { render, staticRenderFns } from "./PurchaseRequisitionList.vue?vue&type=template&id=b1087f5a&"
import script from "./PurchaseRequisitionList.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1087f5a')) {
      api.createRecord('b1087f5a', component.options)
    } else {
      api.reload('b1087f5a', component.options)
    }
    module.hot.accept("./PurchaseRequisitionList.vue?vue&type=template&id=b1087f5a&", function () {
      api.rerender('b1087f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-requisition/PurchaseRequisitionList.vue"
export default component.exports